import { render } from "./FeedbackBtn.vue?vue&type=template&id=0aa62d60&scoped=true"
import script from "./FeedbackBtn.vue?vue&type=script&lang=js"
export * from "./FeedbackBtn.vue?vue&type=script&lang=js"

import "./FeedbackBtn.vue?vue&type=style&index=0&id=0aa62d60&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa62d60"]])

export default __exports__